export const FROM_TO_DATE_FIELDS = ['fromDate', 'toDate'];
